import { AWFExecute, AWFMenuItem } from '@ansys-internal/awf-angular/core';
import { ContributionsEnum } from '../../../contributions.enum';
import { AWFFile, DialogService } from '@ansys-internal/awf-angular/shared';
import { Icons, IconType } from '@ansys-internal/awc-angular/icons';
import { ConceptService } from '../../../../shared/services/concept.service';
import { LoadingComponent } from '../../../../components/dialogs/loading/loading.component';

@AWFMenuItem({
  id: ContributionsEnum.FILES_TABLE_EXPORT_DESIGN_MENU_ITEM,
  priority: 200,
})
export class FilesTableExportDesignMenuItem implements AWFExecute<any> {
  id: string = ContributionsEnum.FILES_TABLE_EXPORT_DESIGN_MENU_ITEM;
  priority: number = 200;
  prefixIcon: IconType = { icon: Icons.PERIODIC };
  text: string = 'Export';

  constructor(
    private dialogService: DialogService,
    private conceptService: ConceptService
  ) {}

  async execute(design: AWFFile): Promise<void> {
    if (design) {
      const dialog = this.dialogService.open(LoadingComponent, {
        title: 'Exporting Concept',
      });

      await this.conceptService.exportConceptFile(design).catch(() => {});

      dialog.close();
    }
  }
}
